import { render, staticRenderFns } from "./socials.vue?vue&type=template&id=19bae857"
import script from "./socials.vue?vue&type=script&lang=js"
export * from "./socials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports